import React from 'react';
import { Grid, Typography, Stepper, Step, StepLabel, StepContent, Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { eligibility, steps, concessions } from '../data';
import { Section, Heading, BulletList } from './common';

const Admission = () => (
  <>
    <Section id="admission">
      <Heading title="Eligibility and how to apply" text="Apply early. Seats in physiotherapy programmes fill quickly." />
      <Grid container spacing={{ xs: 5, md: 8 }}>
        <Grid item xs={12} md={5}>
          <Paper elevation={0} sx={{ p: 4, border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
            <Typography variant="h5" sx={{ color: 'primary.dark', mb: 3 }}>Eligibility</Typography>
            <BulletList items={eligibility} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Stepper orientation="vertical" nonLinear activeStep={-1}>
            {steps.map(([t, d]) => (
              <Step key={t} expanded active>
                <StepLabel StepIconProps={{ sx: { '&.Mui-active': { color: 'primary.main' } } }}>
                  <Typography variant="h6" sx={{ fontSize: '1.1rem', color: 'primary.dark' }}>{t}</Typography>
                </StepLabel>
                <StepContent>
                  <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>{d}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Grid>
      </Grid>
    </Section>

    <Section id="fees" bg="#ffffff">
      <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
        <Grid item xs={12} md={5}>
          <Heading title="Merit-based fee concession" text="SBGI wants quality physiotherapy education to be open to deserving students. Your 12th / PUC score can reduce your BPT fee." sx={{ mb: 3 }} />
          <Typography sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
            For the complete year-wise fee structure and payment schedule, contact the admission office directly. Terms and conditions apply. Pending fees for the next academic year must be cleared by the deadline announced by the college.
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Box sx={{ bgcolor: 'primary.dark', borderRadius: '12px', p: { xs: 3, md: 5 }, color: '#fff' }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255,255,255,0.7)', borderColor: 'rgba(255,255,255,0.2)', fontWeight: 600 }}>Score in 12th / PUC</TableCell>
                    <TableCell align="right" sx={{ color: 'rgba(255,255,255,0.7)', borderColor: 'rgba(255,255,255,0.2)', fontWeight: 600 }}>Fee concession</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {concessions.map(([s, c]) => (
                    <TableRow key={s}>
                      <TableCell sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.2)', fontSize: '1.15rem', py: 3 }}>{s}</TableCell>
                      <TableCell align="right" sx={{ color: 'secondary.main', borderColor: 'rgba(255,255,255,0.2)', fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '2rem' }}>{c}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Button href="#contact" variant="contained" color="secondary" sx={{ mt: 4 }}>Ask about fees</Button>
          </Box>
        </Grid>
      </Grid>
    </Section>
  </>
);

export default Admission;
